module.exports = __webpack_public_path__ + "img/bluetooth-connect.db94b0bd.svg";